export default {
  system: {
    SystemId: '系统ID',
    SystemCode: '系统编号',
    SystemName: '系统名称',
    Effective: '是否生效',
    StatusCanNotEmpty: '状态不能为空',
    SystemNameCanNotEmpty: '系统名称不能为空',
    SystemCodeCanNotEmpty: '系统编号不能为空'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/base/system.js